import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { ResetPassword } from "@faire/retailer-visitor-shared/components/AppSignIn/components/ResetPassword";
import { SignInController } from "@faire/retailer-visitor-shared/components/AppSignIn/components/SignInController";
import { redirectAfterSignIn } from "@faire/retailer-visitor-shared/components/AppSignIn/redirectAfterSignIn";
import { FaireHelmet } from "@faire/retailer-visitor-shared/components/Helmet/index";
import { useSSOErrorStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOErrorStore";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { MANAGE_EMAIL_PREFERENCES, OVERWRITE_COPY_KEY } from "@faire/retailer-visitor-shared/views/settings/email-preferences/EmailPreferencesPage";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { withQueryParams } from "@faire/web--source/common/query-params/withQueryParams";
import { pathMatchesRoute } from "@faire/web--source/common/routes/RouteMatcher";
import { FaireLogo } from "@faire/web--source/slate/logos/FaireLogo";
import { Modal } from "@faire/web--source/slate/Modal";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { route as videoPageRoute } from "@faire/web-api--source/routes/video/videoToken";
import qs from "query-string";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useHistory, withRouter } from "react-router-dom";
import styled from "styled-components";
var AppSignInBase = function(param) {
    var queryParams = param.queryParams;
    var _useState = _sliced_to_array(useState(false), 2), resetSuccess = _useState[0], setResetSuccess = _useState[1];
    var overwriteCopy = queryParams.overwriteCopy, quickLogin = queryParams.quickLogin, resetEmail = queryParams.resetEmail, signIn = queryParams.signIn, email = queryParams.email, ifrp = queryParams.ifrp, livestream = queryParams.livestream, redirectTo = queryParams.redirectTo;
    var resetErrorMessage = useSSOErrorStore().resetErrorMessage;
    var location = useLocation();
    var user = useUserStore([
        "user"
    ]).user;
    var replace = useHistory().replace;
    var handleOnClose = useCallback(function() {
        var _obj;
        var newQuery = qs.stringify(_object_spread_props(_object_spread({}, queryParams), (_obj = {}, _define_property(_obj, OVERWRITE_COPY_KEY, undefined), _define_property(_obj, "quickLogin", undefined), _define_property(_obj, "resetEmail", undefined), _define_property(_obj, "signIn", undefined), _define_property(_obj, "signUp", undefined), _define_property(_obj, "email", undefined), _define_property(_obj, "ifrp", undefined), _define_property(_obj, "livestream", undefined), _define_property(_obj, "redirectTo", undefined), _define_property(_obj, "error", undefined), _obj)));
        var queryString = newQuery ? "?".concat(newQuery) : "";
        resetErrorMessage();
        replace("".concat(location.pathname).concat(queryString));
    }, [
        queryParams,
        resetErrorMessage,
        replace,
        location.pathname
    ]);
    var handleOnLogin = useCallback(function(user) {
        return redirectAfterSignIn(location, user);
    }, [
        location
    ]);
    var handleOnReset = function() {
        return user ? handleOnLogin(user) : setResetSuccess(true);
    };
    useEffect(function() {
        if (!!quickLogin && !!user) {
            if (user === null || user === void 0 ? void 0 : user.is_employee) {
                handleOnLogin(user);
            } else {
                handleOnClose();
            }
        }
    }, [
        quickLogin,
        user,
        handleOnClose,
        handleOnLogin
    ]);
    var dismissible = !livestream && !pathMatchesRoute(location, videoPageRoute);
    var isBrandOnboardingEmailVerification = (redirectTo === null || redirectTo === void 0 ? void 0 : redirectTo.includes("email_verification_token")) && (redirectTo === null || redirectTo === void 0 ? void 0 : redirectTo.includes("validation_token")) && (redirectTo === null || redirectTo === void 0 ? void 0 : redirectTo.includes("brand-onboarding"));
    var specialSignInTitle = useSpecialSignInTitle({
        resetSuccess: resetSuccess,
        isBrandOnboardingEmailVerification: isBrandOnboardingEmailVerification,
        overwriteCopy: overwriteCopy
    });
    if (!!quickLogin && !!user) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Modal, {
        onClose: handleOnClose,
        showCloseButton: dismissible,
        shouldCloseOnOverlayClick: dismissible,
        width: "auto",
        height: "auto",
        padding: "0",
        noPortal: true,
        "data-test-id": "signInModal",
        children: /*#__PURE__*/ _jsxs(ResponsiveContainer, {
            children: [
                location.pathname !== "/" ? /*#__PURE__*/ _jsx(FaireHelmet, {
                    noindex: true
                }) : null,
                /*#__PURE__*/ _jsx(MobileOnlyHeader, {
                    children: /*#__PURE__*/ _jsx(FaireLogo, {
                        size: 110
                    })
                }),
                signIn === "reset-password" && !resetSuccess ? /*#__PURE__*/ _jsx(ResetPassword, {
                    onReset: handleOnReset,
                    resetToken: ifrp
                }) : /*#__PURE__*/ _jsx(SignInController, {
                    onLogin: handleOnLogin,
                    email: email,
                    sendResetEmail: !!resetEmail,
                    signInTitle: specialSignInTitle,
                    isResetPasswordSuccess: resetSuccess
                })
            ]
        })
    });
};
export var AppSignIn = withRouter(withQueryParams(AppSignInBase));
var useSpecialSignInTitle = function(param) {
    var resetSuccess = param.resetSuccess, isBrandOnboardingEmailVerification = param.isBrandOnboardingEmailVerification, overwriteCopy = param.overwriteCopy;
    var strictLocalize = useStrictLocalization().strictLocalize;
    if (resetSuccess || isBrandOnboardingEmailVerification || overwriteCopy === MANAGE_EMAIL_PREFERENCES) {
        return strictLocalize({
            id: "xhCchx",
            defaultMessage: [
                {
                    type: 0,
                    value: "Sign in"
                }
            ]
        });
    }
    return undefined;
};
var ResponsiveContainer = styled.div.withConfig({
    componentId: "sc-a7afe73c-0"
})([
    "width:100%;height:100%;",
    "{display:flex;flex-direction:column;}",
    "{display:flex;flex-direction:row;}"
], responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.desktopAndAbove);
var MobileOnlyHeader = styled.div.withConfig({
    componentId: "sc-a7afe73c-1"
})([
    "display:flex;align-items:center;height:54px;width:100%;border-bottom:1px solid ",
    ";justify-content:flex-start;padding:",
    ";",
    "{display:none;}"
], Core.border.muted, getSpacing(0, "3x"), responsiveMediaQueries.tabletAndAbove);
